import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const myRouters = [
    {
        path: '/',
        redirect: '/express',//首页
    },
    {
        path: '/user',
        name: 'user',
        component: () => import(/* webpackChunkName: "about" */ '../views/userView.vue'),//我的
        meta: {
            title: "我的",
            qixi: true,
            listenIn: true,//埋点
            listenId: 28,
            tabBar: true
        }
    },
    {
        path: '/order',
        name: 'order',
        component: () => import(/* webpackChunkName: "about" */ '../views/orderView.vue'),//查快递
        meta: {
            title: "订单",
            listenIn: true,//埋点
            listenId: 25,
            tabBar: true
        }
    },
    {
        path: '/express',
        name: 'express',
        component: () => import('../views/expressView.vue'),//首页
        meta: {
            title: '寄快递',
            qixi: true,
            listenIn: true,//埋点
            listenId: 26,
            tabBar: true
        }
    },
    {
        path: '/expressNormal',
        name: '/expressNormal',
        component: () => import('../views/expressNormal.vue'),
        meta: {
            title: '寄快递',
            listenIn: true,//埋点
            listenId: 26,
            tabBar: true
        }
    },
    {
        path: '/expressSolid',
        name: '/expressSolid',
        component: () => import('../views/expressSolid.vue'),
        meta: {
            title: '寄快递',
            listenIn: true,//埋点
            listenId: 26,
            tabBar: true
        }
    },
    {
        path: '/expressConcise',
        name: 'expressConcise',
        component: () => import('../views/expressConciseView.vue'),//首页
        meta: {
            title: '寄快递',
            qixi: true,
            listenIn: true,//埋点
            listenId: 26,
            tabBar: true
        }
    },
    {
        path: '/expressBusiness',
        name: 'expressBusiness',
        component: () => import('../views/expressBusinessView.vue'),//首页
        meta: {
            title: '寄快递',
            qixi: true,
            listenIn: true,//埋点
            listenId: 26,
            tabBar: true
        }
    },
    {
        path: '/queryExpressDetail',
        name: 'queryExpressDetail',
        component: () => import('../views/queryExpressDetail.vue'),//订单详情
        meta: {
            title: "快递详情"
        }
    },
    {
        path: '/queryExpressDetailCopy',
        name: 'queryExpressDetailCopy',
        component: () => import('../views/queryExpressDetailCopy.vue'),//订单详情
        meta: {
            title: "快递详情"
        }
    },
    {
        path: '/queryExpressDetailMap',
        name: 'queryExpressDetailMap',
        component: () => import('../views/queryExpressDetailMap.vue'),//订单详情有地图
        meta: {
            title: "快递详情"
        }
    },
    {
        path: '/cancel',
        name: 'cancel',
        component: () => import('../views/cancel.vue'),//取消订单
        meta: {
            title: "取消订单"
        }
    },
    {
        path: '/workAdd',
        name: 'workAdd',
        component: () => import('../views/workAddView.vue'),//提交申诉
        meta: {
            title: "售后申诉"
        }
    },
    {
        path: '/workList',
        name: 'workList',
        component: () => import('../views/workListView.vue'),//申诉列表
        meta: {
            title: "申诉列表",
            listenIn: true,//埋点
            listenId: 1
        }
    },
    {
        path: '/workDetail',
        name: 'workDetail',
        component: () => import('../views/workDetailView.vue'),//申诉详情
        meta: {
            title: "申诉详情"
        }
    },
    {
        path: '/shareposter',
        name: 'shareposter',
        component: () => import('../views/shareposterView.vue'),//分享海报
        meta: {
            title: "推广海报",
            listenIn: true,//埋点
            listenId: 2
        }
    },
    {
        path: '/initcodepath',
        name: 'initcodepath',
        component: () => import('../views/initCodePath.vue'),//分享海报
        meta: {
            title: "二维码创建中",
            listenIn: true,//埋点
            listenId: 2
        }
    },
    {
        path: '/initing',
        name: 'initing',
        component: () => import('../views/initingCodePath.vue'),//分享海报
        meta: {
            title: "二维码创建中",
            listenIn: true,//埋点
            listenId: 2
        }
    },
    {
        path: '/coupon',
        name: 'coupon',
        component: () => import('../views/couponView.vue'),//优惠券列表
        meta: {
            title: "优惠券列表"
        }
    },
    {
        path: '/myIncome',
        name: 'myIncome',
        component: () => import('../views/myIncomeView.vue'),//我的收入
        meta: {
            title: "我的收入",
            listenIn: true,//埋点
            listenId: 3
        }
    },
    {
        path: '/payMoney',
        name: 'payMoney',
        component: () => import('../views/payMoneyView.vue'),//补差价
        meta: {
            title: "补差价",
            listenIn: true,//埋点
            listenId: 4
        }
    },
    {
        path: '/payMoneyDetail',
        name: 'payMoneyDetail',
        component: () => import('../views/payMoneyDetailView.vue'),//补差价详情
        meta: {
            title: "订单补缴"
        }
    },
    {
        path: '/payMoneyBack',
        name: 'payMoneyBack',
        component: () => import('../views/payMoneyBackView.vue'),//我的退款
        meta: {
            title: "我的退款",
            listenIn: true,//埋点
            listenId: 5
        }
    },
    {
        path: '/useraddress',
        name: 'useraddress',
        component: () => import('../views/useraddressView.vue'),//地址簿
        meta: {
            title: "地址管理",
            listenIn: true,//埋点
            listenId: 6
        }
    },
    {
        path: '/sginPersonalOk',
        name: 'sginPersonalOk',
        component: () => import('../views/sginPersonalOkView.vue'),//个人账户
        meta: {
            title: "个人账户",
            listenIn: true,//埋点
            listenId: 7,
            keepAlive: true
        }
    },
    {
        path: '/vip',
        name: 'vip',
        component: () => import('../views/vipView.vue'),//新申请代理
        meta: {
            title: "vip权益",
            listenIn: true,//埋点
            listenId: 8
        }
    },
    {
        path: '/vipJl',
        name: 'vipJl',
        component: () => import('../views/vipJlView.vue'),//新申请代理
        meta: {
            title: "vip权益",
            listenIn: true,//埋点
            listenId: '8-jl'
        }
    },
    {
        path: '/huangjin',
        name: 'huangjin',
        component: () => import('../views/huangjinView.vue'),//黄金代理
        meta: {
            title: "vip申请",
            listenIn: true,//埋点
            listenId: 22
        }
    },
    {
        path: '/baijin',
        name: 'baijin',
        component: () => import('../views/baijinView.vue'),//铂金代理
        meta: {
            title: "vip申请",
            listenIn: true,//埋点
            listenId: 23
        }
    },
    {
        path: '/xingzuan',
        name: 'xingzuan',
        component: () => import('../views/xingzuanView.vue'),//押金代理
        meta: {
            title: "vip申请",
            listenIn: true,//埋点
            listenId: 24
        }
    },
    {
        path: '/gongzhonghao',
        name: 'gongzhonghao',
        component: () => import('../views/gongzhonghao.vue'),//押金代理
        meta: {
            title: "vip申请",
            listenIn: true,//埋点
            listenId: '24a'
        }
    },
    {
        path: '/upgrade',
        name: 'upgrade',
        component: () => import('../views/upgradeView.vue'),//代理升级
        meta: {
            title: "代理升级"
        }
    },
    {
        path: '/becomeAgentOK',
        name: 'becomeAgentOK',
        component: () => import('../views/becomeAgentOKView.vue'),//已提交信息
        meta: {
            title: "vip申请",
            suspension: true,
            listenIn: true,//埋点
            listenId: 20
        }
    },
    {
        path: '/invite',
        name: 'invite',
        component: () => import('../views/inviteView.vue'),//好友列表
        meta: {
            title: "邀约列表",
            listenIn: true,//埋点
            listenId: 9
        }
    },
    {
        path: '/InvitingnewusersJl',
        name: 'InvitingnewusersJl',
        component: () => import('../views/InvitingnewusersJl.vue'),//拉新-极鹭
        meta: {
            title: "拉新奖励"
        }
    },
    {
        path: '/Invitingnewusers',
        name: 'Invitingnewusers',
        component: () => import('../views/Invitingnewusers.vue'),//拉新
        meta: {
            title: "拉新奖励",
            listenIn: true,//埋点
            listenId: 44
        }
    },
    {
        path: '/detailPage',
        name: 'detailPage',
        component: () => import('../views/detailPageView.vue'),//拉新详情
        meta: {
            title: "拉新明细",
            listenIn: true,//埋点
            listenId: 45
        }
    },
    {
        path: '/one',
        name: 'one',
        component: () => import('../views/mailExpressOneView.vue'),//寄快递
        meta: {
            keepAlive: true,
            title: "寄快递",
            suspension: true,
            listenIn: true,//埋点
            listenId: 10
        }
    },
    {
        path: '/big',
        name: 'big',
        component: () => import('../views/mailExpressBigView.vue'),//寄大件
        meta: {
            keepAlive: true,
            title: "寄大件",
            suspension: true,
            listenIn: true,//埋点
            listenId: 11
        }
    },
    {
        path: '/more',
        name: 'more',
        component: () => import('../views/mailExpressMoreView.vue'),//批量寄
        meta: {
            title: "批量寄",
            keepAlive: true
        }
    },
    {
        path: '/predictPrice',
        name: 'predictPrice',
        component: () => import('../intl/predictPrice.vue'),
        meta: {
            keepAlive: true,
            title: "运费查询",
        }
    },
    {
        path: '/inter',
        name: 'inter',
        component: () => import('../views/mailExpressInterView.vue'),//国际
        meta: {
            keepAlive: true,
            title: "国际快递",
            suspension: true,
            listenIn: true,//埋点
            listenId: 14
        }
    },
    {
        path: '/interOffline',
        name: 'interOffline',
        component: () => import('../views/mailExpressInterOfflineView.vue'),//线下邮寄国际
        meta: {
            keepAlive: true,
            title: "国际快递",
            suspension: true,
            listenIn: true,//埋点
            listenId: '14a'
        }
    },
    {
        path: '/local',
        name: 'local',
        component: () => import('../views/mailExpressLocalView.vue'),//同城
        meta: {
            keepAlive: true,
            title: '同城跑腿',
            suspension: true,
            listenIn: true,//埋点
            listenId: 16
        }
    },
    {
        path: '/help',
        name: 'help',
        component: () => import('../views/helpView.vue'),//帮助中心
        meta: {
            title: '常见问题',
            listenIn: true,//埋点
            listenId: 36,
        }
    },
    {
        path: '/chatLink',
        name: 'chatLink',
        component: () => import('../views/chatLink.vue'),//美洽
        meat: {
            listenIn: true,//埋点
            listenId: 17
        }
    },
    {
        path: '/address',
        name: 'address',
        component: () => import('../views/addressView.vue'),//寄件地址
        meta: {
            title: "选择地址"
        }
    },
    {
        path: '/addressSJ',
        name: 'addressSJ',
        component: () => import('../views/addressSJView.vue'),//商家寄件地址
        meta: {
            title: "选择地址"
        }
    },
    {
        path: '/dewuAddress',
        name: 'dewuAddress',
        component: () => import('../views/dewuAddress.vue'),//得物收件地址
        meta: {
            title: "选择地址"
        }
    },
    {
        path: '/AddressAdd',
        name: 'AddressAdd',
        component: () => import('../views/addressAddView.vue'),//添加，修改寄件地址
        meta: {
            title: "添加地址"
        }
    },
    {
        path: '/AddressAddCity',
        name: 'AddressAddCity',
        component: () => import('../views/addressAddCityView.vue'),//添加修改同城地址
        meta: {
            keepAlive: true,
            title: "编辑地址"
        }
    },
    {
        path: '/AddressAddDetail',
        name: 'AddressAddDetail',
        component: () => import('../views/addressAddDetail.vue'),//添加修改同城地址
        meta: {
            title: "编辑地址"
        }
    },
    {
        path: '/rechargeListAdd',
        name: 'rechargeListAdd',
        component: () => import('../views/rechargeListAddView.vue'),//充值记录
        meta: {
            title: "充值列表"
        }
    },
    {
        path: '/rechargeListPay',
        name: 'rechargeListPay',
        component: () => import('../views/rechargeListPayView.vue'),//支付记录
        meta: {
            title: "支付列表"
        }
    },
    {
        path: '/addBankCard',
        name: 'addBankCard',
        component: () => import('../views/addBankCard.vue'),//添加银行卡
    },
    {
        path: '/deal',
        name: 'deal',
        component: () => import('../views/deal.vue'),//服务协议
        meta: {
            title: "服务协议"
        }
    },
    {
        path: '/GjAddress',
        name: 'GjAddress',
        component: () => import('../views/GjAddressView.vue'),//国际地址
        meta: {
            title: "选择地址"
        }
    },
    {
        path: '/GjAddressAdd',
        name: 'GjAddressAdd',
        component: () => import('../views/GjaddressAddView.vue'),//添加，修改国际地址
        meta: {
            title: "编辑地址"
        }
    },
    {
        path: '/addCompanySatus',
        name: 'addCompanySatus',
        component: () => import('../views/addCompanySatus.vue'),//加入企业账户状态
        meta: {
            title: "企业账户"
        }
    },
    {
        path: '/addCompany',
        name: 'addCompany',
        component: () => import('../views/addCompany.vue'),//加入企业账户
        meta: {
            title: "企业账户"
        }
    },
    {
        path: '/sginCompanyOk',
        name: 'sginCompanyOk',
        component: () => import('../views/sginCompanyOk.vue'),//企业账户申请成功
        meta: {
            title: "企业账户"
        }
    },
    {
        path: '/sginCompanyStatus',
        name: 'sginCompanyStatus',
        component: () => import('../views/sginCompanyStatus.vue'),//企业账户审核中
        meta: {
            title: "企业账户"
        }
    },
    {
        path: '/sginCompany',
        name: 'sginCompany',
        component: () => import('../views/sginCompany.vue'),//注册企业账户
        meta: {
            title: "注册开通"
        }
    },
    {
        path: '/editCompany',
        name: 'editCompany',
        component: () => import('../views/editCompany.vue'),//注册企业账户
        meta: {
            title: "修改信息"
        }
    },
    {
        path: '/rechargeList',
        name: 'rechargeList',
        component: () => import('../views/rechargeList.vue'),//企业账户--充值明细
        meta: {
            title: "充值明细"
        }
    }, {
        path: '/consumeList',
        name: 'consumeList',
        component: () => import('../views/consumeList.vue'),//企业账户--消费明细
        meta: {
            title: "消费明细"
        }
    },
    {
        path: '/companyOrderList',
        name: 'companyOrderList',
        component: () => import('../views/companyOrderList.vue'),//企业账户--企业订单
        meta: {
            title: "企业订单"
        }
    },
    {
        path: '/transfer',
        name: 'transfer',
        component: () => import('../views/transfer.vue'),//中转站
        meta: {
            title: "寄快递"
        }
    },
    {
        path: '/pay',
        name: 'pay',
        component: () => import('../views/pay.vue'),//支付组件
        meta: {
            title: "支付页面"
        }
    },
    {
        path: '/receive',
        name: 'receive',
        component: () => import('../views/receive.vue'),//领取代理
        meta: {
            title: "领取代理",
            suspension: true
        }
    },
    {
        path: '/discountCoupon',
        name: 'discountCoupon',
        component: () => import('../views/discountCoupon.vue'),//领取红包
        meta: {
            title: "领取红包",
            suspension: true
        }
    },
    {
        path: '/WelfareSociety',
        name: 'WelfareSociety',
        component: () => import('../views/WelfareSociety.vue'),//福利社
        meta: {
            title: "福利社",
            keepAlive: false,
            tabBar: true
        }
    },
    {
        path: '/exchange',
        name: 'exchange',
        component: () => import('../views/exchange.vue'),    //兑换码
        meta: {
            title: '兑换码',
            keepAlive: false,
            listenIn: true,//埋点
            listenId: 19
        }
    },
    {
        path: '/exchangeVip',
        name: 'exchangeVip',
        component: () => import('../views/exchangeVip.vue'),    //兑换码
        meta: {
            title: '兑换代理',
            keepAlive: false
        }
    },
    {
        path: '/WithdrawalList',
        name: 'WithdrawalList',
        component: () => import('../views/WithdrawalList.vue'),  //提现记录
        meta: {
            title: '提现记录',
            keepAlive: false
        }
    },
    {
        path: '/inviteactivity',
        name: 'inviteactivity',
        component: () => import('../views/inviteactivity.vue'),    //推荐用户
        meta: {
            title: '推荐用户',
            keepAlive: false
        }
    },
    {
        path: '/school',
        name: 'school',
        component: () => import('../views/school.vue'),    //商学院
        meta: {
            title: '商学院',
            keepAlive: false,
            listenIn: true,//埋点
            listenId: 18
        }
    },
    {
        path: '/video',
        name: 'video',
        component: () => import('../views/video.vue'),    //观看课程
        meta: {
            title: '观看课程',
            keepAlive: false
        }
    },
    {
        path: '/applicationGeren',
        name: 'applicationGeren',
        component: () => import('../views/applicationGeren.vue'),    //=申请报名
        meta: {
            title: '申请报名',
            keepAlive: false
        }
    },
    {
        path: '/applicationGongzhonghao',
        name: 'applicationGongzhonghao',
        component: () => import('../views/applicationGongzhonghao.vue'),    //=申请报名
        meta: {
            title: '申请报名',
            keepAlive: false
        }
    },
    {
        path: '/sfPayment',
        name: 'sfPayment',
        component: () => import('../views/sfPayment.vue'),    //极鹭活动
        meta: {
            title: '顺丰到付',
            keepAlive: false,
            listenIn: true,//埋点
            listenId: 21
        }
    },
    {
        path: '/batchAddressAdd',
        name: 'batchAddressAdd',
        component: () => import('../views/batchAddressAdd.vue'),    //极鹭活动
        meta: {
            title: '添加地址',
            keepAlive: false,
        }
    },
    {
        path: '/intelligent',
        name: 'intelligent',
        component: () => import('../views/intelligent.vue'),    //达人招募
        meta: {
            title: '达人招募',
            keepAlive: false,
        }
    },
    {
        path: '/business',
        name: 'business',
        component: () => import('../views/business.vue'),    //商家寄件
        meta: {
            title: '商家寄件',
            keepAlive: false,
            listenIn: true,//埋点
            listenId: 35,
        }
    }, {
        path: '/businessMore',
        name: 'businessMore',
        component: () => import('../views/businessMore.vue'),    //商家寄件
        meta: {
            title: '商家批量寄件',
            keepAlive: false,
        }
    }, {
        path: '/businessOne',
        name: 'businessOne',
        component: () => import('../views/businessOne.vue'),    //商家寄件
        meta: {
            title: '商家寄快递',
            keepAlive: true,
        }
    }, {
        path: '/joinList',
        name: 'joinList',
        component: () => import('../views/joinList.vue'),    //商家寄件
        meta: {
            title: '成员列表',
            keepAlive: false,
        }
    },
    {
        path: '/SharingRebates',
        name: 'SharingRebates',
        component: () => import('../views/SharingRebates.vue'),    //分享下单
        meta: {
            title: '分享下单',
            keepAlive: false,
        }
    },
    {
        path: '/redEnvelope',
        name: 'redEnvelope',
        component: () => import('../views/redEnvelope.vue'),    //红包活动
        meta: {
            title: '分享领红包',
            keepAlive: false,
            listenIn: true,//埋点
            listenId: 30,
            shareFlag: true
        }
    },
    {
        path: '/redEnvelopeCopy',
        name: 'redEnvelopeCopy',
        component: () => import('../views/redEnvelopeCopy.vue'),    //红包活动
        meta: {
            title: '分享领红包',
            keepAlive: false,
            shareFlag: true
        }
    },
    {
        path: '/mailExpressBusiness',
        name: 'mailExpressBusiness',
        component: () => import('../views/mailExpressBusiness.vue'),    //excel
        meta: {
            title: '商家寄件',
            keepAlive: false

        }
    },
    {
        path: '/serviceStandards',
        name: 'serviceStandards',
        component: () => import('../views/serviceStandards.vue'),    //服务标准
        meta: {
            title: '服务标准',
            keepAlive: false,
        }
    },
    {
        path: '/importExcel',
        name: 'importExcel',
        component: () => import('../views/importExcel.vue'),    //导入excel
        meta: {
            title: 'Excel导入',
            keepAlive: false,
        }
    },
    {
        path: '/operatingInstructions',
        name: 'operatingInstructions',
        component: () => import('../views/operatingInstructions.vue'),    //操作说明
        meta: {
            title: '操作说明',
            keepAlive: false,
        }
    },
    {
        path: '/queryPrice',
        name: 'queryPrice',
        component: () => import('../views/queryPrice.vue'),    //查询报价
        meta: {
            title: '查询报价',
            keepAlive: false,
        }
    },
    {
        path: '/queryPriceJt',
        name: 'queryPriceJt',
        component: () => import('../views/queryPriceJt.vue'),    //寄件价格表（极兔）
        meta: {
            title: '寄件价格表',
            keepAlive: false,
        }
    },
    {
        path: '/queryPriceHome',
        name: 'queryPriceHome',
        component: () => import('../views/queryPriceHome.vue'),    //首页查询报价
        meta: {
            title: '查询报价',
            keepAlive: false,
            listenIn: true,//埋点
            listenId: 41
        }
    },
    {
        path: '/boshi',
        name: 'boshi',
        component: () => import('../views/Aboshi.vue'),    //测试
        meta: {
            title: '测试',
            keepAlive: true,
        }
    },
    {
        path: '/queryEwm',
        name: 'queryEwm',
        component: () => import('../views/queryExpressDetailEwm.vue'),    //快递详情
        meta: {
            title: '快递详情',
            keepAlive: false,
        }
    },
    {
        path: '/msgCenter',
        name: 'msgCenter',
        component: () => import('../views/msgCenter.vue'),    //消息中心
        meta: {
            title: '消息中心',
            keepAlive: false,
            listenIn: true,//埋点
            listenId: 40
        }
    },
    {
        path: '/invoice',
        name: 'invoiceApplication',
        component: () => import('../views/invoiceApplication.vue'),    //发票申请
        meta: {
            title: '申请发票',
            keepAlive: false,
        }
    },
    {
        path: '/history',
        name: 'invoiceHistory',
        component: () => import('../views/invoiceHistory.vue'),    //发票历史
        meta: {
            title: '开票历史',
            keepAlive: false,
        }
    },
    {
        path: '/lookup',
        name: 'invoiceLookUp.vue',
        component: () => import('../views/invoiceLookUp.vue'),    //发票抬头管理
        meta: {
            title: '抬头管理',
            keepAlive: false,
        }
    },
    {
        path: '/invoiceDetail',
        name: 'invoiceDetail',
        component: () => import('../views/invoiceDetail.vue'),    //发票详情
        meta: {
            title: '发票详情',
            keepAlive: false,
        }
    },
    {
        path: '/invoicePreView',
        name: 'invoicePreView',
        component: () => import('../views/invoicePreview.vue'),    //发票详情
        meta: {
            title: '发票详情',
            keepAlive: false,
        }
    },
    {
        path: '/invoiceLookUpAdd',
        name: 'invoiceLookUpAdd',
        component: () => import('../views/invoiceLookUpAdd.vue'),    //新增抬头
        meta: {
            title: '新增抬头',
            keepAlive: false,
        }
    },
    {
        path: '/selectlookUp',
        name: 'selectlookUp',
        component: () => import('../views/selectlookUp.vue'),    //选择发票抬头
        meta: {
            title: '选择发票抬头',
            keepAlive: false,
        }
    },
    {
        path: '/checkInvoice',
        name: 'checkInvoice',
        component: () => import('../views/checkInvoice.vue'),    //核对发票信息
        meta: {
            title: '核对发票信息',
            keepAlive: false,
        }
    },
    {
        path: '/redBook',
        name: 'redBook',
        component: () => import('../views/redBook.vue'),    //核对发票信息
        meta: {
            title: '晒单有奖',
            keepAlive: false,
        }
    },
    {
        path: '/queryPriceInter',
        name: 'queryPriceInter',
        component: () => import('../views/queryPriceInter.vue'),//寄件价格查询
        meta: {
            title: '寄件价格查询'
        }
    },
    {
        path: '/prohibited',
        name: 'prohibited',
        component: () => import('../views/prohibited.vue'),//禁止寄件
        meta: {
            title: '查违禁品'
        }
    },
    {
        path: '/remoteQuery',
        name: 'remoteQuery',
        component: () => import('../views/remoteQuery.vue'),//偏远查询
        meta: {
            title: '偏远查询'
        }
    },
    {
        path: '/commonQuestion',
        name: 'commonQuestion',
        component: () => import('../views/commonQuestion.vue'),//常见问题
        meta: {
            title: '常见问题',
        }
    },
    {
        path: '/coverImg',
        name: 'coverImg',
        component: () => import('../views/coverImg.vue'),//
    },
    {
        path: '/exclusive',
        name: 'exclusive',
        component: () => import('../views/exclusive.vue'),//转世客服
        meta: {
            title: '专属客服'
        }
    },
    {
        path: '/Consolidation',
        name: 'Consolidation',
        component: () => import('../views/Consolidation.vue'),//网购集运转运步骤
        meta: {
            title: '网购集运转运步骤'
        }
    },
    {
        path: '/prohibitedItems',
        name: 'prohibitedItems',
        component: () => import('../views/prohibitedItems.vue'),//网购集运转运步骤
        meta: {
            title: '违禁物品',
            listenIn: true,//埋点
            listenId: 37
        }
    },
    {
        path: '/measurement',
        name: 'measurement',
        component: () => import('../views/measurement.vue'),//神秘黑手
        meta: {
            title: '神秘黑手',
            keepAlive: true
        }
    },
    {
        path: '/couponPack',
        name: 'couponPack',
        component: () => import('../views/couponPack.vue'),//优惠券包
        meta: {
            title: '优惠券包'
        }
    },
    {
        path: '/againOrder',
        name: 'againOrder',
        component: () => import('../views/againOrder.vue'),//重新下单
        meta: {
            title: '重新寄快递',
            listenIn: true,//埋点
            listenId: 46
        }
    },
    {
        path: '/example',
        name: 'example',
        component: () => import('../views/example.vue'),
        meta: {
            title: '计费规则'
        }
    },
    {
        path: '/sceneIndex',
        name: 'sceneIndex',
        component: () => import('../intl/sceneIndex.vue'),
        meta: {
            title: '寄件下单'
        }
    },
    {
        path: '/helpIsuse',
        name: 'helpIsuse',
        component: () => import('../intl/helpIsuse.vue'),
        meta: {
            title: '常见问题'
        }
    },
    {
        path: '/queryprohibitIndex',
        name: 'queryprohibitIndex',
        component: () => import('../intl/queryprohibitIndex.vue'),
        meta: {
            title: '禁限查询'
        }
    },
    {
        path: '/queryremoteIndex',
        name: 'queryremoteIndex',
        component: () => import('../intl/queryremoteIndex.vue'),
        meta: {
            title: '偏远查询'
        }
    },
    {
        path: '/lineDetail',
        name: 'lineDetail',
        component: () => import('../intl/lineDetail.vue'),
        meta: {
            title: '寄运信息'
        }
    },
    {
        path: '/lineDetailHst',
        name: 'lineDetailHst',
        component: () => import('../intl/lineDetailHst.vue'),
        meta: {
            title: '寄运信息'
        }
    },
    {
        path: '/vipIndex',
        name: 'vipIndex',
        component: () => import('../intl/vipIndex.vue'),
        meta: {
            title: 'vip'
        }
    },
    {
        path: '/vipApply',
        name: 'vipApply',
        component: () => import('../intl/vipApply.vue'),
        meta: {
            title: '会员开通'
        }
    },
    {
        path: '/waitPutStorageIndex',
        name: 'waitPutStorageIndex',
        component: () => import('../intl/waitPutStorageIndex.vue'),
        meta: {
            title: '待入库'
        }
    },
    {
        path: '/logisticsIndex',
        name: 'logisticsIndex',
        component: () => import('../intl/logisticsIndex.vue'),
        meta: {
            title: '物流查询'
        }
    },
    {
        path: '/packOrderIndex',
        name: 'packOrderIndex',
        component: () => import('../intl/packOrderIndex.vue'),
        meta: {
            title: '申请打包'
        }
    },
    {
        path: '/packOrderPackMsg',
        name: 'packOrderPackMsg',
        component: () => import('../intl/packOrderPackMsg.vue'),
        meta: {
            title: '申请打包',
            keepAlive: true
        }
    },
    {
        path: '/packOrderSelectLine',
        name: 'packOrderSelectLine',
        component: () => import('../intl/packOrderSelectLine.vue'),
        meta: {
            title: '选择路线'
        }
    },
    {
        path: '/intlIndex',
        name: 'intlIndex',
        component: () => import('../intl/intlIndex.vue'),
        meta: {
            title: '寄件下单'
        }
    },
    {
        path: '/predictionIndex',
        name: 'predictionIndex',
        component: () => import('../intl/predictionIndex.vue'),
        meta: {
            title: '包裹预报',
            keepAlive: true
        }
    },
    {
        path: '/mailexpressIntl',
        name: 'mailexpressIntl',
        component: () => import('../intl/mailexpressIntl.vue'),
        meta: {
            title: '国际快递',
            keepAlive: true
        }
    },
    {
        path: '/mailexpressIntlOnline',
        name: 'mailexpressIntlOnline',
        component: () => import('../intl/mailexpressIntlOnline.vue'),
        meta: {
            title: '国际快递',
            keepAlive: true
        }
    },
    {
        path: '/helpIndex',
        name: 'helpIndex',
        component: () => import('../intl/helpIndex.vue'),
        meta: {
            title: '操作指引'
        }
    },
    {
        path: '/wareAddressIndex',
        name: 'wareAddressIndex',
        component: () => import('../intl/wareAddressIndex.vue'),
        meta: {
            title: '仓库地址'
        }
    },
    {
        path: '/clauseAgreement',
        name: 'clauseAgreement',
        component: () => import('../intl/clauseAgreement.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/clauseDisclaimer',
        name: 'clauseDisclaimer',
        component: () => import('../intl/clauseDisclaimer.vue'),
        meta: {
            title: ''
        }
    },
    {
        path: '/categoryIndex',
        name: 'categoryIndex',
        component: () => import('../intl/categoryIndex.vue'),
        meta: {
            title: '选择物品品类'
        }
    },

    {
        path: '/promotionCoupon',
        name: 'promotionCoupon',
        component: () => import('../views/promotionCoupon.vue'),
        meta: {
            title: '外卖券',
            listenIndex: true,
            listenId: 69,
            keepAlive: true
        }
    },

    {
        path: '/promotionIncome',
        name: 'promotionIncome',
        component: () => import('../views/promotionIncome.vue'),
        meta: {
            title: '收益数据'
        }
    },

    {
        path: '/promotionAddress',
        name: 'promotionAddress',
        component: () => import('../views/promotionAddress.vue'),
        meta: {
            title: '选择地址'
        }
    },
    {
        path: '/promotionBwcDetail',
        name: 'promotionBwcDetail',
        component: () => import('../views/promotionBwcDetail.vue'),
        meta: {
            title: '外卖券详情'
        }
    },
    {
        path: '/promotionSginUpDetail',
        name: 'promotionSginUpDetail',
        component: () => import('../views/promotionSginUpDetail.vue'),
        meta: {
            title: '外卖券详情'
        }
    },
    {
        path: '/promotionSginUpList',
        name: 'promotionSginUpList',
        component: () => import('../views/promotionSginUpList.vue'),
        meta: {
            title: '外卖券列表'
        }
    },
    {
        path: '/promotionSearchShow',
        name: 'promotionSearchShow',
        component: () => import('../views/promotionSearchShow.vue'),
        meta: {
            title: '外卖券',
            keepAlive: true
        }
    },
    {
        path: '/checkInCar',
        name: 'checkInCar',
        component: () => import('../views/checkInCar.vue'),
        meta: {
            title: '车辆/电器托运',
            keepAlive: true
        }
    },
    {
        path: '/incomeDetail',
        name: 'incomeDetail',
        component: () => import('../views/incomeDetail.vue'),
        meta: {
            title: '活动详情'
        }
    },
    {
        path: '/customLink',
        name: 'customLink',
        component: () => import('../views/customLink.vue'),
        meta: {
            title: '单聊-AI客服系统',
        }
    },
    {
        path: '/serviseIntl',
        name: 'serviseIntl',
        component: () => import('../intl/serviseIntl.vue'),
        meta: {
            title: '我的客服',
        }
    },
     {
        path: '/shareXhs',
        name: 'shareXhs',
        component: () => import('../views/shareXhs.vue'),
        meta: {
            title: '分享小红书',
        }
    },
    {
        path: '/merchantTransfer',
        name: 'merchantTransfer',
        component: () => import('../views/merchantTransfer.vue'),
        meta: {
            title: '商家转账',
        }
    },
    {
        path: '/authorization',
        name: 'authorization',
        component: () => import('../views/authorization.vue'),
        meta: {
            title: '提现账户授权',
        }
    }
]
const router = new VueRouter({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: myRouters
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()

})
export default router
